/** 复刻页独立于我的 IP 资格门禁；本地带项目前缀，部署使用公开路径。 */
export function getViralRemakeRoute(development: boolean): string {
  return development ? '/--roboneo/viral-remake' : '/viral-remake';
}
